/**
 * ProtectedLayout — wraps every authed route in AuthGuard + Shell.
 *
 * Used as a react-router v6 layout route (no `path`, just an `element`).
 * Nested <Route>s render their `element` inside <Outlet /> below.
 *
 * Usage in app.tsx:
 *   <Route element={<ProtectedLayout />}>
 *     <Route path="/dashboard" element={<DashboardPage />} />
 *     <Route path="/organizations" element={<OrganizationList />} />
 *     …
 *   </Route>
 */
import { Outlet } from 'react-router-dom';

import { AuthGuard } from '../../auth/AuthGuard.js';
import { BreadcrumbTailProvider } from './BreadcrumbTailContext.js';
import { Shell } from './Shell.js';

export function ProtectedLayout() {
  return (
    <AuthGuard>
      <BreadcrumbTailProvider>
        <Shell>
          <Outlet />
        </Shell>
      </BreadcrumbTailProvider>
    </AuthGuard>
  );
}
